import React from "react";

const Preloader = ({ loading }) => {
  return <div className={`preloader ${loading ? "loading" : ""}`}></div>;
};

export default Preloader;
